import React, { Dispatch } from "react";

// Small type hack here so we don't have to do null checks 
// before calling setters
const noop = (() => {}) as unknown as Dispatch<unknown>;

export const SDKContext = React.createContext<{
  components: any;
  design: any;
  error: string;
  sdk: any;
  viewToggles: any;
  setComponents: Dispatch<any>;
  setDesign: Dispatch<any>;
  setError: Dispatch<string>;
  setSDK: Dispatch<any>;
  setViewToggles: Dispatch<any>;
}>({
  components: null,
  design: null,
  error: '',
  sdk: null,
  viewToggles: null,
  setComponents: noop,
  setDesign: noop,
  setError: noop,
  setSDK: noop,
  setViewToggles: noop,
});
